import { render, staticRenderFns } from "./_fixedPurchases.vue?vue&type=template&id=405682ae&scoped=true&"
import script from "./_fixedPurchases.vue?vue&type=script&lang=js&"
export * from "./_fixedPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405682ae",
  null
  
)

export default component.exports